import Alpine from 'alpinejs';
import { Vote } from './election-config/my_types';
import { TVoteRequest, TVoteResponse } from './election-config/generated_types';
import { authFetch } from './election-config/generated_requests';

type VoteForm = {
  init?: () => void
  vote: Vote
  submitVote: (vote: Vote) => void
}

type VoteResponse = {
  redirectUrl: string
}

document.addEventListener('alpine:init', () => {
  Alpine.data<VoteForm, any[]>("vote_form", (voterlink: string, voterreceipt?: string) => {
    return {

      vote: {
        answers: {}
      },

      init() {
        const _this = this
        this.$el.addEventListener("htmx:beforeRequest", function (event) {

          if (event.detail.requestConfig.triggeringEvent.type === "submit") {

            event.preventDefault(); // Prevent the form from submitting normally
              
            // // Process the form data
            // const formData = new FormData(event.target);
            // const answers = buildTreeFromVotes(getVotesFromFormData(formData))
            // // Wrap everything inside "answers" key
            // const result = { answers };

            // Modify the request data (set it as JSON)
            event.detail.xhr.setRequestHeader("Content-Type", "application/json");
            event.detail.xhr.send(JSON.stringify(_this.vote));
          }
        });
      },

      async submitVote() {

        const body: TVoteRequest = {
          voterlink: voterlink,
          voterreceipt: voterreceipt ?? "",
          vote: JSON.stringify(this.vote)
        }

        // --- CSRF token handling ---
        let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content || "";
        const resp = await authFetch(window.location.origin + window.location.pathname, {
          headers: {
            "X-Csrf-Token": csrfToken
          }, 
          method: "POST", 
          body: JSON.stringify(body)
        })
        let voteResp
        if (resp.status === 200) {
          voteResp = await resp.json()
          window.location.href = voteResp.redirectUrl
        }

        // const data: TVoteResponse = await resp.json()
        // VoteRequest({election: electionId, voterlink: voterlink, voterreceipt: votereceipt ?? "", vote: JSON.stringify(vote)})
      },
    }
  })
})